import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataResolverService {

  public paymentResponse: any = {};
  public homeRoute = 'pooja-booking';

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    | Observable<Observable<any>> | Promise<Observable<any>> {
    return this.getPaymentResponse();
  }

  setPaymentResponse(data: any) {
    this.paymentResponse = data;
  }

  getPaymentResponse() {
    return this.paymentResponse;
  }

  setHomeRoute(data: any) {
    this.homeRoute = data;
  }

  getHomeRoute() {
    return this.homeRoute;
  }



}
